export const breakpoints = {
  upto: {
    small: '(max-width: 599.98px)',
    medium: '(max-width: 959.98px)',
  },
  from: {
    small: '(min-width: 600px)',
    medium: '(min-width: 960px)',
  },
};
